/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTextFieldDefinition
 */
export interface ControlTextFieldDefinition {
    /**
     * 
     * @type {string}
     * @memberof ControlTextFieldDefinition
     */
    field_type?: string;
}

/**
 * Check if a given object implements the ControlTextFieldDefinition interface.
 */
export function instanceOfControlTextFieldDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlTextFieldDefinitionFromJSON(json: any): ControlTextFieldDefinition {
    return ControlTextFieldDefinitionFromJSONTyped(json, false);
}

export function ControlTextFieldDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTextFieldDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field_type': !exists(json, 'field_type') ? undefined : json['field_type'],
    };
}

export function ControlTextFieldDefinitionToJSON(value?: ControlTextFieldDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field_type': value.field_type,
    };
}

